<div class="notification-wrapper" *ngIf="hasPermission">
  <button class="btn-notification" (click)="toggle()" type="button">
    <i class="bi bi-bell icon-outline"></i>
    <i class="bi bi-bell-fill icon-fill"></i>
    <span *ngIf="unreadCount > 0" class="badge">{{ unreadCount > 9 ? '9+' : unreadCount }}</span>
  </button>

  <div class="notification-dropdown" *ngIf="isOpen">
    <div class="dropdown-header">
      <span>Notificaciones</span>
      <button class="btn-mark-all" (click)="markAllAsRead($event)" *ngIf="unreadCount > 0">
        Marcar todas como leídas
      </button>
    </div>

    <div class="notification-list" *ngIf="!isLoading && unreadNotifications.length > 0; else emptyOrLoading">
      <div class="notification-item" *ngFor="let notification of unreadNotifications">
        <button class="btn-mark-read" (click)="markAsRead($event, notification)" title="Marcar como leída">
          <i class="bi bi-eye"></i>
        </button>
        <div class="notification-content">
          <span class="notification-module">{{ notification.module }}</span>
          <span class="notification-title">{{ notification.title }}</span>
          <span class="notification-date">{{ notification.date | ago }}</span>
        </div>
      </div>
    </div>

    <ng-template #emptyOrLoading>
      <div class="loading-state" *ngIf="isLoading; else emptyState">
        <i class="bi bi-arrow-repeat spin"></i>
        <span>Cargando...</span>
      </div>
      <ng-template #emptyState>
        <div class="empty-state">
          <i class="bi bi-bell-slash"></i>
          <span>No hay notificaciones sin leer</span>
        </div>
      </ng-template>
    </ng-template>

    <div class="dropdown-footer">
      <button class="btn-view-all" (click)="goToNotificationCenter()">
        Ver centro de notificaciones
      </button>
    </div>
  </div>
</div>
